import AxiosStatic from "axios";
import User from "./user-management";
import { FullDetailsError } from "./fullDetailsError";

class UserManagementService {
  $http = AxiosStatic

  async createNewUser(user: User) {
    return this.$http.post("/api/user/createUser", user)
      .catch(this.formatErrorsAndRethrowWithStatus);
  }

  async tryLinkUser(userRequest: any) {
    return this.$http.post("/api/user/tryLinkUser", userRequest)
      .catch(this.formatErrorsAndRethrowWithStatus);
  }

  async updateUser(user: User) {
    return this.$http.post("/api/user/updateUser", user)
          .catch(error => {
            this.formatErrorsAndRethrow(error)
          });
  }

  async deleteLinkBusinessUser(userID: number, businessID: Number) {
    return this.$http.post("/api/user/removeLinkedUser", { userID, businessID })
      .catch(this.formatErrorsAndRethrow);
  }

  async getCurrentUserProfile() {
    return this.$http.post("/api/user/getCurrentUserProfile");
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatErrorsAndRethrow(error: any) {
    if (error.response) {
      let err = error.response.data;
      if (err.errors) {
        err = [...Object.keys(error.response.data.errors).map(
          key => error.response.data.errors[key]
        )];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((flat: any, list: any) => flat.concat(list));
        console.log(err);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((val: any, arr: any) => `${val} \r\n${arr}`, "")
      }
      throw new Error(err);
    }
    else {
      throw new Error("An unexpected error has occurred");
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatFirstErrorAndRethrow(error: any) {
    if (error.response) {
      let err = error.response.data;
      if (err.errors) {
        err = [...Object.keys(error.response.data.errors).map(
          key => error.response.data.errors[key]
        )];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        err = err.reduce((flat: any, list: any) => flat.concat(list));
        console.log(err);
      }
      throw new Error(err[0]);
    }
    else {
      throw new Error("An unexpected error has occurred");
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private formatErrorsAndRethrowWithStatus(error: any) {
    if (error.response) {
      const err = error.response.data;
      throw new FullDetailsError(err, error).getExtraDetails();
    }
    else {
      throw new Error("An unexpected error has occurred");
    }
  }
}
export default new UserManagementService()
